var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c(
        "main",
        { staticClass: "dashboardBackground grey" },
        [
          _c("kravicka-paralax", { attrs: { kravicka: _vm.kravicka } }),
          _vm._v(" "),
          _vm.kravicka.kravicka_pozadie
            ? _c("img", {
                staticClass: "dashboadMobileBackground",
                attrs: { src: "assets/img/" + _vm.paralaxMobile, alt: "" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("kravicka-animacia-apng", {
            ref: "kravickaAnimacieApng",
            on: {
              showBubble: _vm.showBubble,
              hideBubble: _vm.hideBubble,
              animationEnded: _vm.animationEnded
            }
          }),
          _vm._v(" "),
          _vm.hlaska != ""
            ? _c("div", { staticClass: "o-bubble" }, [
                _c("div", { staticClass: "m-bubble__content" }, [
                  _c("div", { staticClass: "a-bubble__text" }, [
                    _vm._v(_vm._s(_vm.hlaska))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "m-bubble__close",
                    on: {
                      click: function($event) {
                        _vm.hlaska = ""
                      }
                    }
                  },
                  [_c("span", { staticClass: "icon" })]
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "aside",
        { staticClass: "dashboardControls w-100 h-100" },
        [
          _c("header-kravicka", {
            attrs: { profil: _vm.profil, show: _vm.show },
            on: {
              updateProfil: _vm.emitUpdateProfil,
              hideBottomControls: _vm.hideBottomControls,
              "update:show": function($event) {
                _vm.show = $event
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dashboradControlsBottom fixed-bottom",
              style: "z-index:" + _vm.stastomerZindex
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "rowitems d-flex align-items-end justify-content-between"
                },
                [
                  _c("div", { staticClass: "dashboardControlsBottom__left" }, [
                    _c(
                      "div",
                      { staticClass: "o-stastomer d-none d-md-block" },
                      [
                        _c(
                          "div",
                          { class: "stastomerWrap" + _vm.statsDetailOpen },
                          [
                            _c("div", { staticClass: "m-stastomerImg" }, [
                              _c("div", { staticClass: "a-stastomerBgCircle" }),
                              _vm._v(" "),
                              _vm.kravicka.kravicka_img_hlava
                                ? _c("img", {
                                    attrs: {
                                      src:
                                        "https://www.adoptujkravicku.sk/data/foto/" +
                                        _vm.kravicka.kravicka_img_hlava,
                                      alt: ""
                                    }
                                  })
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "m-stastomerZdravie" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "a-stastomerZdravie__button",
                                  on: {
                                    click: function($event) {
                                      return _vm.statsMenu()
                                    }
                                  }
                                },
                                [_c("span", { staticClass: "icon" })]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "a-stastomerZdravie__hodnota" },
                                [_vm._v(_vm._s(_vm.param_global) + "%")]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "m-stastomerInfo" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "a-stastomerInfo__button",
                                  on: {
                                    click: function($event) {
                                      return _vm.$bvModal.show("modalInfo")
                                    }
                                  }
                                },
                                [_c("span", { staticClass: "icon" })]
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { class: "m-stastomerDetail" + _vm.statsOpen },
                          [
                            _c(
                              "div",
                              { staticClass: "a-stastomerDetail__name" },
                              [
                                _c("p", [
                                  _vm._v(_vm._s(_vm.kravicka.kravicka_meno))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "a-stastomerDetail__progressbars"
                              },
                              [
                                _c("div", { staticClass: "progressBarBody" }, [
                                  _c(
                                    "span",
                                    { staticClass: "progressBarTitle" },
                                    [_vm._v("Jedlo")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "progressBar" }, [
                                    _c("span", {
                                      staticClass:
                                        "progressBarValue progressFood",
                                      style: {
                                        width:
                                          _vm.kravicka.kravicka_param_jedlo +
                                          "%"
                                      }
                                    })
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "progressBarBody" }, [
                                  _c(
                                    "span",
                                    { staticClass: "progressBarTitle" },
                                    [_vm._v("Pitie")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "progressBar" }, [
                                    _c("span", {
                                      staticClass:
                                        "progressBarValue progressDrink",
                                      style: {
                                        width:
                                          _vm.kravicka.kravicka_param_pitie +
                                          "%"
                                      }
                                    })
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "progressBarBody" }, [
                                  _c(
                                    "span",
                                    { staticClass: "progressBarTitle" },
                                    [_vm._v("Zábava")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "progressBar" }, [
                                    _c("span", {
                                      staticClass:
                                        "progressBarValue progressFun",
                                      style: {
                                        width:
                                          _vm.kravicka.kravicka_param_zabava +
                                          "%"
                                      }
                                    })
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "progressBarBody" }, [
                                  _c(
                                    "span",
                                    { staticClass: "progressBarTitle" },
                                    [_vm._v("Čistota")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "progressBar" }, [
                                    _c("span", {
                                      staticClass:
                                        "progressBarValue progressCleanness",
                                      style: {
                                        width:
                                          _vm.kravicka.kravicka_param_cistota +
                                          "%"
                                      }
                                    })
                                  ])
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "a-stastomer__close",
                                on: {
                                  click: function($event) {
                                    return _vm.statsMenu()
                                  }
                                }
                              },
                              [_c("span", { staticClass: "icon" })]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        class: "o-stastomer --mobile d-md-none " + _vm.statsOpen
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "m-stastomer__button--mobile" },
                          [
                            _c("div", { staticClass: "a-stastomerBgCircle" }),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src:
                                  "https://www.adoptujkravicku.sk/data/foto/" +
                                  _vm.kravicka.kravicka_img_hlava,
                                alt: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.statsMenu()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "a-stastomerZdravie__hodnota" },
                              [_vm._v(_vm._s(_vm.param_global) + "%")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "stastomerWrap" }, [
                          _c("div", { staticClass: "m-stastomerImg" }, [
                            _c("div", { staticClass: "a-stastomerBgCircle" }),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src:
                                  "https://www.adoptujkravicku.sk/data/foto/" +
                                  _vm.kravicka.kravicka_img_hlava,
                                alt: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.statsMenu()
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "m-stastomerZdravie" }, [
                            _vm._m(0),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "a-stastomerZdravie__hodnota" },
                              [_vm._v(_vm._s(_vm.param_global) + "%")]
                            )
                          ]),
                          _vm._v(" "),
                          _vm._m(1)
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-stastomerDetail" }, [
                          _c(
                            "div",
                            { staticClass: "a-stastomerDetail__name" },
                            [
                              _c("p", [
                                _vm._v(_vm._s(_vm.kravicka.kravicka_meno))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "a-stastomerDetail__progressbars" },
                            [
                              _c("div", { staticClass: "progressBarBody" }, [
                                _c(
                                  "span",
                                  { staticClass: "progressBarTitle" },
                                  [_vm._v("Jedlo")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "progressBar" }, [
                                  _c("span", {
                                    staticClass:
                                      "progressBarValue progressFood",
                                    style: {
                                      width:
                                        _vm.kravicka.kravicka_param_jedlo + "%"
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "progressBarBody" }, [
                                _c(
                                  "span",
                                  { staticClass: "progressBarTitle" },
                                  [_vm._v("Pitie")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "progressBar" }, [
                                  _c("span", {
                                    staticClass:
                                      "progressBarValue progressDrink",
                                    style: {
                                      width:
                                        _vm.kravicka.kravicka_param_pitie + "%"
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "progressBarBody" }, [
                                _c(
                                  "span",
                                  { staticClass: "progressBarTitle" },
                                  [_vm._v("Zábava")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "progressBar" }, [
                                  _c("span", {
                                    staticClass: "progressBarValue progressFun",
                                    style: {
                                      width:
                                        _vm.kravicka.kravicka_param_zabava + "%"
                                    }
                                  })
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "progressBarBody" }, [
                                _c(
                                  "span",
                                  { staticClass: "progressBarTitle" },
                                  [_vm._v("Čistota")]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "progressBar" }, [
                                  _c("span", {
                                    staticClass:
                                      "progressBarValue progressCleanness",
                                    style: {
                                      width:
                                        _vm.kravicka.kravicka_param_cistota +
                                        "%"
                                    }
                                  })
                                ])
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "a-stastomer__overlay" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "a-stastomerMobile__button--close",
                            on: {
                              click: function($event) {
                                return _vm.statsMenu()
                              }
                            }
                          },
                          [_c("span", { staticClass: "icon" })]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "dashboardControlsBottom__right" }, [
                    _c("div", { staticClass: "o-itemsButtons" }, [
                      _c(
                        "div",
                        {
                          class:
                            "m-itemsButtons__additional" + _vm.rightMenuOpen
                        },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.left",
                                  modifiers: { hover: true, left: true }
                                }
                              ],
                              staticClass: "a-itemButton",
                              attrs: { title: "Obchod" },
                              on: {
                                click: function($event) {
                                  _vm.$router.push({
                                    name: "obchod",
                                    params: {
                                      kategoria: "food",
                                      kravicka_id: _vm.kravicka.id
                                    }
                                  })
                                  _vm.rightMenu()
                                }
                              }
                            },
                            [_c("span", { staticClass: "icon --cart" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.left",
                                  modifiers: { hover: true, left: true }
                                }
                              ],
                              staticClass: "a-itemButton",
                              attrs: { title: "Jedlo" },
                              on: {
                                click: function($event) {
                                  _vm.inventarMenu("food", "Jedlo")
                                  _vm.rightMenu()
                                }
                              }
                            },
                            [_c("span", { staticClass: "icon --food" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.left",
                                  modifiers: { hover: true, left: true }
                                }
                              ],
                              staticClass: "a-itemButton",
                              attrs: { title: "Pitie" },
                              on: {
                                click: function($event) {
                                  _vm.inventarMenu("drink", "Pitie")
                                  _vm.rightMenu()
                                }
                              }
                            },
                            [_c("span", { staticClass: "icon --drink" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.left",
                                  modifiers: { hover: true, left: true }
                                }
                              ],
                              staticClass: "a-itemButton",
                              attrs: { title: "Čistota" },
                              on: {
                                click: function($event) {
                                  _vm.inventarMenu("cleanness", "Čistota")
                                  _vm.rightMenu()
                                }
                              }
                            },
                            [_c("span", { staticClass: "icon --clean" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.left",
                                  modifiers: { hover: true, left: true }
                                }
                              ],
                              staticClass: "a-itemButton",
                              attrs: { title: "Šatník" },
                              on: {
                                click: function($event) {
                                  _vm.$router.push({
                                    name: "satnik",
                                    params: {
                                      kategoria: "satnik",
                                      kravicka_id: _vm.kravicka.id
                                    }
                                  })
                                  _vm.rightMenu()
                                }
                              }
                            },
                            [_c("span", { staticClass: "icon --shirt" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.left",
                                  modifiers: { hover: true, left: true }
                                }
                              ],
                              staticClass: "a-itemButton",
                              attrs: { title: "Pozadie" },
                              on: {
                                click: function($event) {
                                  _vm.inventarMenu("background", "Pozadie")
                                  _vm.rightMenu()
                                }
                              }
                            },
                            [_c("span", { staticClass: "icon --image" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover.left",
                                  modifiers: { hover: true, left: true }
                                }
                              ],
                              staticClass: "a-itemButton",
                              attrs: { title: "Minihry" },
                              on: {
                                click: function($event) {
                                  _vm.inventarMenu("games", "Minihry")
                                  _vm.rightMenu()
                                }
                              }
                            },
                            [_c("span", { staticClass: "icon --games" })]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "m-itemsButtons_main",
                          on: {
                            click: function($event) {
                              return _vm.rightMenu()
                            }
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "img-fluid",
                            attrs: {
                              src: "assets/img/cowIcon.svg",
                              alt: "Cow Icon"
                            }
                          })
                        ]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c("inventar-kravicka", {
                attrs: {
                  menuOpen: _vm.menuOpen,
                  menuOpenKategoria: _vm.menuOpenKategoria,
                  menuOpenNazov: _vm.menuOpenNazov,
                  kravicka: _vm.kravicka
                },
                on: {
                  hideInventar: _vm.hideInventarMenu,
                  useInventarProdukt: _vm.useInventoryProduct
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalInfo",
          attrs: {
            id: "modalInfo",
            "hide-footer": "",
            "hide-header": "",
            centered: "",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "modalInfoTitle",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "b-button",
            {
              staticClass: "m-modalInfo__close",
              attrs: { block: "" },
              on: {
                click: function($event) {
                  return _vm.$bvModal.hide("modalInfo")
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body o-modalInfo" }, [
            _c("h2", { staticClass: "m-modalInfo__name text-center" }, [
              _vm._v(_vm._s(_vm.kravicka.kravicka_meno))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "m-modalInfo_imageWrap" }, [
              _c("div", { staticClass: "a-modalInfo__bgCircle" }, [
                _c("img", {
                  attrs: {
                    src:
                      "https://www.adoptujkravicku.sk/data/foto/" +
                      _vm.kravicka.kravicka_img_hlava,
                    alt: ""
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "a-modalInfoZdravie" }, [
                _c("a", { staticClass: "modalInfoZdravie__button" }, [
                  _c("span", { staticClass: "icon" })
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "modalInfoZdravie__hodnota" }, [
                  _vm._v(_vm._s(_vm.param_global) + "%")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "a-facebookShare" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn --facebook",
                    attrs: { href: "https://www.facebook.com/AdoptujKravicku/" }
                  },
                  [_c("span", { staticClass: "icon" })]
                )
              ])
            ]),
            _vm._v(" "),
            _vm.kravicka.ean_kravicky
              ? _c("div", { staticClass: "m-modalInfo__cowData" }, [
                  _c("table", [
                    _c("tr", [
                      _c("td", [_vm._v("Počet zadaných EAN kódov")]),
                      _vm._v(" "),
                      _c("td", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.kravicka.ean_kravicky.length))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("Moje číslo")]),
                      _vm._v(" "),
                      _c("td", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.kravicka.kravicka_regcislo))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("Bývam na farme")]),
                      _vm._v(" "),
                      _c("td", { staticClass: "value" }, [
                        _vm._v(_vm._s(_vm.kravicka.dvor_id.dvor_nazov))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [_vm._v("Dátum narodenia")]),
                      _vm._v(" "),
                      _c("td", { staticClass: "value" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("moment")(
                              _vm.kravicka.kravicka_datum_nar,
                              "D.M.YYYY"
                            )
                          )
                        )
                      ])
                    ])
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "m-modalInfo__footer d-flex" }, [
              _c(
                "div",
                { staticClass: "a-modalInfo__misc" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "adoptCow",
                      attrs: { href: "http://adoptujkravicku.sk/kravicky/" }
                    },
                    [
                      _c("span", { staticClass: "icon" }),
                      _vm._v("Adoptovať ďalšiu kravičku\n                    ")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass: "editData",
                      attrs: {
                        to: {
                          name: "uprava-kravicky",
                          params: {
                            kravicka_id: _vm.kravicka.id,
                            kravicka_meno: _vm.kravicka.kravicka_meno,
                            kravicka_meno_rodica:
                              _vm.kravicka.kravicka_meno_rodica
                          }
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "icon" }),
                      _vm._v("Upraviť údaje\n                    ")
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "a-modalInfo__btn" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn --primary",
                    attrs: {
                      href:
                        "https://adoptujkravicku.sk/hra/kravicka/rodny-list/" +
                        _vm.kravicka.id
                    }
                  },
                  [
                    _c("span", { staticClass: "icon-certificate" }),
                    _vm._v("Rodný list\n                    ")
                  ]
                )
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "a-stastomerZdravie__button" }, [
      _c("span", { staticClass: "icon" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "m-stastomerInfo" }, [
      _c("a", { staticClass: "a-stastomerInfo__button" }, [
        _c("span", {
          staticClass: "icon",
          attrs: { "data-toggle": "modal", "data-target": "#modalInfo" }
        })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }